// Helped class for Task
export default class Task {
  constructor (
    title,
    description,
    whatWatch,
    time,
    tags,
    completed,
    editing,
    user = null,
    id = null,
    timeStart,
    timeStart2,
    idHome,
    opisaniye,
    datePickerStart,
    timePickerStart,
    datePickerEnd,
    timePickerEnd,
    boxNumber,
    startDate,
    endDate
  ) {
    this.title = title
    this.description = description
    this.whatWatch = whatWatch
    this.time = time
    this.tags = tags
    this.completed = completed
    this.editing = editing
    this.user = user
    this.id = id
    this.timeStart = timeStart
    this.timeStart2 = timeStart2
    this.idHome = idHome
    this.opisaniye = opisaniye
    this.datePickerStart = datePickerStart
    this.timePickerStart = timePickerStart
    this.datePickerEnd = datePickerEnd
    this.timePickerEnd = timePickerEnd
    this.boxNumber = boxNumber
    this.startDate = startDate
    this.endDate = endDate
  }
}



// WEBPACK FOOTER //
// ./src/store/task_help.js